module.exports = __webpack_public_path__ + "img/inventory_bar_wide.3eb0ac13.png";